import { render, staticRenderFns } from "./idea.vue?vue&type=template&id=55fded91&scoped=true"
import script from "./idea.vue?vue&type=script&lang=js"
export * from "./idea.vue?vue&type=script&lang=js"
import style0 from "./idea.vue?vue&type=style&index=0&id=55fded91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fded91",
  null
  
)

export default component.exports